import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import HomePage from "@/pages/HomePage";
import BirthdayBookingPage from "@/pages/BirthdayBookingPage";
import MascotBookingPage from "@/pages/MascotBookingPage";
import CandyBarBookingPage from "@/pages/CandyBarBookingPage";
import StemRegistrationPage from "@/pages/StemRegistrationPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book/birthday" element={<BirthdayBookingPage />} />
            <Route path="/book/mascot" element={<MascotBookingPage />} />
            <Route path="/book/candy-bar" element={<CandyBarBookingPage />} />
            <Route path="/register/stem" element={<StemRegistrationPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
